// Maps a login username (no "@") to the real Supabase Auth email.
// Supabase Auth is email-based; this lets the single admin log in with a
// memorable username as well as the email. The target email comes from
// REACT_APP_SUPABASE_ADMIN_EMAIL (set in .env), falling back to the known
// admin address. Add more entries if needed.
const ADMIN_EMAIL =
  process.env.REACT_APP_SUPABASE_ADMIN_EMAIL;

const adminAliases = {
  hectorduran2801: ADMIN_EMAIL,
};

// Resolve a typed identifier to an email. If it already looks like an email
// (contains "@") it is returned unchanged; otherwise it is looked up in the
// alias map (case-insensitive), falling back to the raw value.
export function resolveLoginEmail(identifier) {
  const value = (identifier || "").trim();
  if (value.includes("@")) return value;
  return adminAliases[value.toLowerCase()] || value;
}

export default adminAliases;
